import { render, staticRenderFns } from "./fonts-upload.vue?vue&type=template&id=0a7bf604"
import script from "./fonts-upload.vue?vue&type=script&lang=js"
export * from "./fonts-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports